(function(window, document, $, undefined){
  $('.search-results .posts-per-page-select select').change(function() {
        $('.posts-per-page-select form').submit();
    });

})(window, document, jQuery);
